import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { UserRoles } from 'types';
import ProtectedRoute from './components/ProtectedRoute';

//Common
import BaseLayout from 'modules/Layouts';
import { HomePage } from 'modules/Home';
import NotFoundPage from 'modules/NotFoundPage';
//Login
import { LoginPage } from 'modules/LogIn/Login';
import { PasswordResetPage } from 'modules/LogIn/PasswordReset';
import { CreateNewPasswordPage } from 'modules/LogIn/CreateNewPassword';
//Clients
import CustomersAndRestaurantsPage from 'modules/CustomersAndRestaurants';
import CreateCustomerPage from 'modules/CustomersAndRestaurants/Customers/CreateCustomer';
import { CreateCustomerPageNewUi } from 'modules/CustomersAndRestaurants/Customers/CreateCustomerNewUi';
import { EditCustomerPageNewUi } from 'modules/CustomersAndRestaurants/Customers/EditCustomerNewUi';
import CustomersPage from 'modules/CustomersAndRestaurants/Customers/Customers';
import { CustomersPageNewUi } from 'modules/CustomersAndRestaurants/Customers/CustomersNewUi';
import EditCustomerPage from 'modules/CustomersAndRestaurants/Customers/EditCustomer';
import CreateRestaurantPage from 'modules/CustomersAndRestaurants/Restaurants/CreateRestaurant';
import EditRestaurantPage from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant';
import RestaurantsPage from 'modules/CustomersAndRestaurants/Restaurants/Restaurants';
//Menu
import MenuPage from 'modules/Menu';
import CategoryPage from 'modules/Menu/Category/Category';
import CreateCategoryPage from 'modules/Menu/Category/CreateCategory';
import EditCategoryPage from 'modules/Menu/Category/EditCategory';
import ChangeCategoryPositionPage from 'modules/Menu/Category/ChangeCategoryPosition';
import SubcategoryPage from 'modules/Menu/SubCategory/SubCategory';
import CreateSubCategoryPage from 'modules/Menu/SubCategory/CreateSubCategory';
import EditSubCategoryPage from 'modules/Menu/SubCategory/EditSubCategory';
import ChangeSubCategoryPositionPage from 'modules/Menu/SubCategory/ChangeSubCategoryPosition';
import DishesPage from 'modules/Menu/Dishes/Dishes';
import CreateDishPage from 'modules/Menu/Dishes/CreateDish';
import EditDishPage from 'modules/Menu/Dishes/EditDish';
import ChangeDishPositionPage from 'modules/Menu/Dishes/ChangeDishPosition';
import DishAssignmentPage from 'modules/Menu/Dishes/DishAssignment';
import ModifierGroupsPage from 'modules/Menu/ModifierGroups/ModifierGroups';
import CreateModifierGroupsPage from 'modules/Menu/ModifierGroups/CreateModifierGroups';
import EditModifierGroupsPage from 'modules/Menu/ModifierGroups/EditModifierGroups';
import ModifiersPage from 'modules/Menu/Modifiers/Modifiers';
import CreateModifierPage from 'modules/Menu/Modifiers/CreateModifier';
import EditModifierPage from 'modules/Menu/Modifiers/EditModifier';
import ChangeModifierPositionPage from 'modules/Menu/Modifiers/ChangeModifierPosition';
import ComboGroupPage from 'modules/Menu/ComboGroup/ComboGroup';
import CreateComboGroupPage from 'modules/Menu/ComboGroup/CreateComboGroup';
import EditComboGroupPage from 'modules/Menu/ComboGroup/EditComboGroup';
import ChangeComboGroupPositionPage from 'modules/Menu/ComboGroup/ChangeComboGroupPosition';
//MenuV2
import MenuPageV2 from 'modules/MenuV2';
import { CategoryPageV2 } from 'modules/MenuV2/Category/Category';
import { CreateCategoryPageV2 } from 'modules/MenuV2/Category/CreateCategory';
import { EditCategoryPageV2 } from 'modules/MenuV2/Category/EditCategory';
import { ChangeCategoryPositionPageV2 } from 'modules/MenuV2/Category/ChangeCategoryPosition';
import { EditCategoryRestaurantPropertiesPage } from 'modules/MenuV2/Category/EditCategoryRestaurantProperties';
import { ViewCategoryPageV2 } from 'modules/MenuV2/Category/ViewCategory';
import { SubcategoryPageV2 } from 'modules/MenuV2/SubCategory/Subcategory';
import { CreateSubcategoryPageV2 } from 'modules/MenuV2/SubCategory/CreateSubcategory';
import { EditSubcategoryPageV2 } from 'modules/MenuV2/SubCategory/EditSubcategory';
import { ChangeSubCategoryPositionPageV2 } from 'modules/MenuV2/SubCategory/ChangeSubCategoryPosition';
import { EditSubcategoryRestaurantPropertiesPage } from 'modules/MenuV2/SubCategory/EditSubcategoryRestaurantProperties';
import { ViewSubcategoryPageV2 } from 'modules/MenuV2/SubCategory/ViewSubcategory';
import { DishesPageV2 } from 'modules/MenuV2/Dishes/Dishes';
import { CreateDishPageV2 } from 'modules/MenuV2/Dishes/CreateDish';
import { EditDishPageV2 } from 'modules/MenuV2/Dishes/EditDish';
import { ChangeDishPositionPageV2 } from 'modules/MenuV2/Dishes/ChangeDishPosition';
import { ChangePortionPositionPage } from 'modules/MenuV2/Dishes/ChangePortionPosition';
import { DishAssignmentPageV2 } from 'modules/MenuV2/Dishes/DishAssignment';
import { EditDishRestaurantPropertiesPage } from 'modules/MenuV2/Dishes/EditDishRestaurantProperties';
import { ViewDishPageV2 } from 'modules/MenuV2/Dishes/ViewDish';
import { ModifierGroupsPageV2 } from 'modules/MenuV2/ModifierGroups/ModifierGroups';
import { CreateModifierGroupsPageV2 } from 'modules/MenuV2/ModifierGroups/CreateModifierGroups';
import { ViewModifierGroupsPageV2 } from 'modules/MenuV2/ModifierGroups/ViewModifierGroups';
import { EditModifierGroupPageV2 } from 'modules/MenuV2/ModifierGroups/EditModifierGroups';
import { EditModifierGroupRestaurantPropertiesPage } from 'modules/MenuV2/ModifierGroups/EditModifierGroupRestaurantProperties';
import { ModifiersPageV2 } from 'modules/MenuV2/Modifiers/Modifiers';
import { CreateModifierPageV2 } from 'modules/MenuV2/Modifiers/CreateModifier';
import { EditModifierPageV2 } from 'modules/MenuV2/Modifiers/EditModifier';
import { EditModifierRestaurantPropertiesPage } from 'modules/MenuV2/Modifiers/EditModifierRestaurantProperties';
import { ViewModifierPageV2 } from 'modules/MenuV2/Modifiers/ViewModifier';
//Teasers
import TeasersPage from 'modules/Teasers/Teasers';
import CreateTeaserPage from 'modules/Teasers/CreateTeaser';
import EditTeaserPage from 'modules/Teasers/EditTeaser';
//Entertainment
import EntertainmentPage from 'modules/Entertainment';
import CreateGamePage from 'modules/Entertainment/Games/CreateGame';
import CreateGameCategoryPage from 'modules/Entertainment/Games/CreateGameCategory';
import EditGamePage from 'modules/Entertainment/Games/EditGame';
import EditGameCategoryPage from 'modules/Entertainment/Games/EditGameCategory';
import GameAssignmentPage from 'modules/Entertainment/Games/GameAssignment';
import GameCategoriesPage from 'modules/Entertainment/Games/GameCategories';
import GameDevelopersPage from 'modules/Entertainment/Games/GameDevelopers';
import GamesPage from 'modules/Entertainment/Games/Games';
import ChangeGamePositionPage from 'modules/Entertainment/Games/ChangeGamePosition';
import VideosPage from 'modules/Entertainment/Videos/Videos';
import CreateVideoPage from 'modules/Entertainment/Videos/CreateVideo';
import EditVideoPage from 'modules/Entertainment/Videos/EditVideo';
import VideoCategoriesPage from 'modules/Entertainment/Videos/VideoCategories';
import CreateVideoCategoryPage from 'modules/Entertainment/Videos/CreateVideoCategory';
import EditVideoCategoryPage from 'modules/Entertainment/Videos/EditVideoCategory';
import VideoStudiosPage from 'modules/Entertainment/Videos/VideoStudios';
import VideosAssignmentPage from 'modules/Entertainment/Videos/VideosAssignment';
//Users
import UsersPage from 'modules/Users/Users';
import CreateUserPage from 'modules/Users/CreateUser';
import EditUserPage from 'modules/Users/EditUser';
import UserInfoPage from 'modules/Users/UserProfile';
//Devices
import DevicesPage from 'modules/Devices/Devices';
import CreateDevicePage from 'modules/Devices/CreateDevice';
import EditDevicePage from 'modules/Devices/EditDevice';
//Watches
import { WatchesPage } from 'modules/Watches/Watches';
import { CreateWatchPage } from 'modules/Watches/CreateWatch';
import { EditWatchPage } from 'modules/Watches/EditWatch';
//App
import FirmwareAndAppPage from 'modules/FirmwareAndApp';
import ApkPage from 'modules/FirmwareAndApp/Apk/Apk';
import ApkAssignmentPage from 'modules/FirmwareAndApp/Apk/ApkAssignment';
import CreateApkPage from 'modules/FirmwareAndApp/Apk/CreateApk';
import EditApkPage from 'modules/FirmwareAndApp/Apk/EditApk';
import CreateFirmwarePage from 'modules/FirmwareAndApp/Firmware/CreateFirmware';
import EditFirmwarePage from 'modules/FirmwareAndApp/Firmware/EditFirmware';
import FirmwarePage from 'modules/FirmwareAndApp/Firmware/Firmware';
import FirmwareAssignmentPage from 'modules/FirmwareAndApp/Firmware/FirmwareAssignment';
//Credentials
import { CredentialsPage } from 'modules/Credentials/Credentials';
import { CreateCredentialsPage } from 'modules/Credentials/CreateCredentials';
import { EditCredentialsPage } from 'modules/Credentials/EditCredentials';
//Admin settings
import WordingsPage from 'modules/AdminSettings/Wordings';
import AddWordingsPage from 'modules/AdminSettings/AddWordings';

let CustomersAndRestaurantsRoutes = () => {
	return (
		<Switch>
			<Route exact={true} path="/clients" component={CustomersAndRestaurantsPage} />
			<ProtectedRoute
				exact={true}
				path="/clients/customers/create"
				component={CreateCustomerPage}
				permittedRoles={[UserRoles.SUPER_USER]}
			/>
			<ProtectedRoute
				exact={true}
				path="/clients/customers/edit"
				component={EditCustomerPage}
				permittedRoles={[
					UserRoles.SUPER_USER,
					UserRoles.CLIENT_MANAGER,
					UserRoles.GROUP_MANAGER,
					UserRoles.TECHNICAL,
				]}
			/>
			<ProtectedRoute
				exact={true}
				path="/clients/customers"
				component={CustomersPage}
				permittedRoles={[
					UserRoles.SUPER_USER,
					UserRoles.CLIENT_MANAGER,
					UserRoles.GROUP_MANAGER,
					UserRoles.TECHNICAL,
				]}
			/>
			<ProtectedRoute
				exact={true}
				path="/clients/customers-new-ui"
				component={CustomersPageNewUi}
				permittedRoles={
					process.env.HAS_CUSTOMERS_NEW_UI
						? [UserRoles.SUPER_USER, UserRoles.CLIENT_MANAGER, UserRoles.GROUP_MANAGER, UserRoles.TECHNICAL]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/clients/customers-new-ui/create"
				component={CreateCustomerPageNewUi}
				permittedRoles={process.env.HAS_CUSTOMERS_NEW_UI ? [UserRoles.SUPER_USER] : []}
			/>
			<ProtectedRoute
				exact={true}
				path="/clients/customers-new-ui/edit"
				component={EditCustomerPageNewUi}
				permittedRoles={
					process.env.HAS_CUSTOMERS_NEW_UI
						? [UserRoles.SUPER_USER, UserRoles.CLIENT_MANAGER, UserRoles.GROUP_MANAGER, UserRoles.TECHNICAL]
						: []
				}
			/>
			<Route exact={true} path="/clients/restaurants" component={RestaurantsPage} />
			<ProtectedRoute
				exact={true}
				path="/clients/restaurants/create"
				component={CreateRestaurantPage}
				permittedRoles={[UserRoles.SUPER_USER]}
			/>
			<Route exact={true} path="/clients/restaurants/edit" component={EditRestaurantPage} />
		</Switch>
	);
};

let MenuRoutes = () => {
	return (
		<Switch>
			<Route exact={true} path="/menu" component={MenuPage} />
			<Route exact={true} path="/menu/category" component={CategoryPage} />
			<Route exact={true} path="/menu/category/create" component={CreateCategoryPage} />
			<Route exact={true} path="/menu/category/edit" component={EditCategoryPage} />
			<Route exact={true} path="/menu/category/positions" component={ChangeCategoryPositionPage} />
			<Route exact={true} path="/menu/subcategory" component={SubcategoryPage} />
			<Route exact={true} path="/menu/subcategory/create" component={CreateSubCategoryPage} />
			<Route exact={true} path="/menu/subcategory/edit" component={EditSubCategoryPage} />
			<Route exact={true} path="/menu/subcategory/positions" component={ChangeSubCategoryPositionPage} />
			<Route exact={true} path="/menu/dishes" component={DishesPage} />
			<Route exact={true} path="/menu/dishes/create" component={CreateDishPage} />
			<Route exact={true} path="/menu/dishes/edit" component={EditDishPage} />
			<Route exact={true} path="/menu/dishes/positions" component={ChangeDishPositionPage} />
			<Route exact={true} path="/menu/dishes-assignment" component={DishAssignmentPage} />
			<Route exact={true} path="/menu/modifier-groups" component={ModifierGroupsPage} />
			<Route exact={true} path="/menu/modifier-groups/create" component={CreateModifierGroupsPage} />
			<Route exact={true} path="/menu/modifier-groups/edit" component={EditModifierGroupsPage} />
			<Route exact={true} path="/menu/modifiers" component={ModifiersPage} />
			<Route exact={true} path="/menu/modifiers/create" component={CreateModifierPage} />
			<Route exact={true} path="/menu/modifiers/edit" component={EditModifierPage} />
			<Route exact={true} path="/menu/modifiers/positions" component={ChangeModifierPositionPage} />
			<Route exact={true} path="/menu/combo-group" component={ComboGroupPage} />
			<Route exact={true} path="/menu/combo-group/create" component={CreateComboGroupPage} />
			<Route exact={true} path="/menu/combo-group/edit" component={EditComboGroupPage} />
			<Route exact={true} path="/menu/combo-group/positions" component={ChangeComboGroupPositionPage} />
		</Switch>
	);
};

let MenuRoutesV2 = () => {
	return (
		<Switch>
			<ProtectedRoute
				exact={true}
				path="/menu-v2"
				component={MenuPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/category"
				component={CategoryPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/category/create"
				component={CreateCategoryPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/category/edit"
				component={EditCategoryPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/category/positions"
				component={ChangeCategoryPositionPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/category/edit-restaurant-properties"
				component={EditCategoryRestaurantPropertiesPage}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/category/view"
				component={ViewCategoryPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/subcategory"
				component={SubcategoryPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/subcategory/create"
				component={CreateSubcategoryPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/subcategory/edit"
				component={EditSubcategoryPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/subcategory/positions"
				component={ChangeSubCategoryPositionPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/subcategory/edit-restaurant-properties"
				component={EditSubcategoryRestaurantPropertiesPage}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/subcategory/view"
				component={ViewSubcategoryPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/dishes"
				component={DishesPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/dishes/create"
				component={CreateDishPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/dishes/edit"
				component={EditDishPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/dishes/positions"
				component={ChangeDishPositionPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/dishes/portion-positions"
				component={ChangePortionPositionPage}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/dishes-assignment"
				component={DishAssignmentPageV2}
				permittedRoles={
					process.env.HAS_DISH_ASSIGNMENT_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/dishes/edit-restaurant-properties"
				component={EditDishRestaurantPropertiesPage}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/dishes/view"
				component={ViewDishPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/modifier-groups"
				component={ModifierGroupsPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/modifier-groups/create"
				component={CreateModifierGroupsPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/modifier-groups/edit"
				component={EditModifierGroupPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/modifier-groups/view"
				component={ViewModifierGroupsPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/modifier-groups/edit-restaurant-properties"
				component={EditModifierGroupRestaurantPropertiesPage}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/modifiers"
				component={ModifiersPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/modifiers/create"
				component={CreateModifierPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/modifiers/view"
				component={ViewModifierPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/modifiers/edit"
				component={EditModifierPageV2}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
			<ProtectedRoute
				exact={true}
				path="/menu-v2/modifiers/edit-restaurant-properties"
				component={EditModifierRestaurantPropertiesPage}
				permittedRoles={
					process.env.HAS_MENU_V2
						? [
								UserRoles.SUPER_USER,
								UserRoles.CLIENT_MANAGER,
								UserRoles.GROUP_MANAGER,
								UserRoles.RESTAURANT_MANAGER,
								UserRoles.TECHNICAL,
								UserRoles.WAITER,
								UserRoles.RKL_SUPPORT_MANAGER,
						  ]
						: []
				}
			/>
		</Switch>
	);
};

let TeasersRoutes = () => {
	return (
		<Switch>
			<Route exact={true} path="/teasers" component={TeasersPage} />
			<ProtectedRoute
				exact={true}
				path="/teasers/create"
				component={CreateTeaserPage}
				permittedRoles={[
					UserRoles.SUPER_USER,
					UserRoles.CLIENT_MANAGER,
					UserRoles.GROUP_MANAGER,
					UserRoles.TECHNICAL,
				]}
			/>
			<ProtectedRoute
				exact={true}
				path="/teasers/edit"
				component={EditTeaserPage}
				permittedRoles={[
					UserRoles.SUPER_USER,
					UserRoles.CLIENT_MANAGER,
					UserRoles.GROUP_MANAGER,
					UserRoles.RESTAURANT_MANAGER,
					UserRoles.TECHNICAL,
				]}
			/>
		</Switch>
	);
};

let EntertainmentRoutes = () => {
	return (
		<Switch>
			<Route exact={true} path="/entertainment" component={EntertainmentPage} />
			<ProtectedRoute
				exact={true}
				path="/entertainment/games"
				component={GamesPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/games/create"
				component={CreateGamePage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/games/edit"
				component={EditGamePage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/games/developers"
				component={GameDevelopersPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/games/categories"
				component={GameCategoriesPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/games/categories/create"
				component={CreateGameCategoryPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/games/categories/edit"
				component={EditGameCategoryPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/games/games-assign"
				component={GameAssignmentPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/games/positions"
				component={ChangeGamePositionPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/videos"
				component={VideosPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/videos/create"
				component={CreateVideoPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/videos/edit"
				component={EditVideoPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/videos/categories"
				component={VideoCategoriesPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/videos/categories/create"
				component={CreateVideoCategoryPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/videos/categories/edit"
				component={EditVideoCategoryPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/videos/studios"
				component={VideoStudiosPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/entertainment/videos/videos-assign"
				component={VideosAssignmentPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
		</Switch>
	);
};

let UserRoutes = () => {
	return (
		<Switch>
			<ProtectedRoute
				exact={true}
				path="/users"
				component={UsersPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/users/create"
				component={CreateUserPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/users/edit"
				component={EditUserPage}
				permittedRoles={[UserRoles.SUPER_USER]}
			/>
			<Route exact={true} path="/users/me" component={UserInfoPage} />
		</Switch>
	);
};

let DevicesRoutes = () => {
	return (
		<Switch>
			<ProtectedRoute
				exact={true}
				path="/devices"
				component={DevicesPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/devices/create"
				component={CreateDevicePage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/devices/edit"
				component={EditDevicePage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
		</Switch>
	);
};

let WatchesRoutes = () => {
	return (
		<Switch>
			<ProtectedRoute
				exact={true}
				path="/watches"
				component={WatchesPage}
				permittedRoles={process.env.HAS_WATCHES ? [UserRoles.SUPER_USER, UserRoles.TECHNICAL] : []}
			/>
			<ProtectedRoute
				exact={true}
				path="/watches/create"
				component={CreateWatchPage}
				permittedRoles={process.env.HAS_WATCHES ? [UserRoles.SUPER_USER, UserRoles.TECHNICAL] : []}
			/>
			<ProtectedRoute
				exact={true}
				path="/watches/edit"
				component={EditWatchPage}
				permittedRoles={process.env.HAS_WATCHES ? [UserRoles.SUPER_USER, UserRoles.TECHNICAL] : []}
			/>
		</Switch>
	);
};

let FirmwareAndAppRoutes = () => {
	return (
		<Switch>
			<ProtectedRoute
				exact={true}
				path="/app"
				component={FirmwareAndAppPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/app/tablet-app"
				component={ApkPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/app/tablet-app/create"
				component={CreateApkPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/app/tablet-app/edit"
				component={EditApkPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/app/tablet-app/assignment"
				component={ApkAssignmentPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/app/firmware"
				component={FirmwarePage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/app/firmware/create"
				component={CreateFirmwarePage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/app/firmware/edit"
				component={EditFirmwarePage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/app/firmware/assignment"
				component={FirmwareAssignmentPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
		</Switch>
	);
};

let CredentialsRoutes = () => {
	return (
		<Switch>
			<ProtectedRoute
				exact={true}
				path="/credentials"
				component={CredentialsPage}
				permittedRoles={[UserRoles.SUPER_USER]}
			/>
			<ProtectedRoute
				exact={true}
				path="/credentials/create"
				component={CreateCredentialsPage}
				permittedRoles={[UserRoles.SUPER_USER]}
			/>
			<ProtectedRoute
				exact={true}
				path="/credentials/edit"
				component={EditCredentialsPage}
				permittedRoles={[UserRoles.SUPER_USER]}
			/>
		</Switch>
	);
};

let AdminSettingsRoutes = () => {
	return (
		<Switch>
			<ProtectedRoute
				exact={true}
				path="/adminSettings"
				component={WordingsPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
			<ProtectedRoute
				exact={true}
				path="/adminSettings/add"
				component={AddWordingsPage}
				permittedRoles={[UserRoles.SUPER_USER, UserRoles.TECHNICAL]}
			/>
		</Switch>
	);
};

let Routes: React.FC = () => {
	return (
		<Switch>
			<Route
				exact={true}
				path="/home"
				component={BaseLayout(HomePage, { hideSidebar: false, hideHeaderNav: false })}
			/>

			<Route
				exact={true}
				path="/"
				component={BaseLayout(LoginPage, {
					hideSidebar: true,
					hideHeaderNav: true,
					hideHeaderProfile: true,
					// displayFooter: true,
				})}
			/>
			<Route
				exact={true}
				path="/password-reset"
				component={BaseLayout(PasswordResetPage, {
					hideSidebar: true,
					hideHeaderNav: true,
					hideHeaderProfile: true,
					// displayFooter: true,
				})}
			/>
			<Route
				exact={true}
				path="/create-new-password"
				component={BaseLayout(CreateNewPasswordPage, {
					hideSidebar: true,
					hideHeaderNav: true,
					hideHeaderProfile: true,
					// displayFooter: true,
				})}
			/>

			<Route path="/clients" component={BaseLayout(CustomersAndRestaurantsRoutes)} />
			<Route path="/menu" component={BaseLayout(MenuRoutes)} />
			<Route path="/menu-v2" component={BaseLayout(MenuRoutesV2)} />
			<Route path="/teasers" component={BaseLayout(TeasersRoutes)} />
			<Route path="/entertainment" component={BaseLayout(EntertainmentRoutes)} />
			<Route path="/users" component={BaseLayout(UserRoutes)} />
			<Route path="/devices" component={BaseLayout(DevicesRoutes)} />
			<Route path="/watches" component={BaseLayout(WatchesRoutes)} />
			<Route path="/app" component={BaseLayout(FirmwareAndAppRoutes)} />
			<Route path="/credentials" component={BaseLayout(CredentialsRoutes)} />
			<Route path="/adminSettings" component={BaseLayout(AdminSettingsRoutes)} />

			<Route exact={true} path="/healthcheck">
				<h3>Hey There!!! The App is Healthy</h3>
			</Route>

			<Route component={NotFoundPage} />
		</Switch>
	);
};

export default Routes;
